/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelProcessLog.ts                    *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/general/process-log";

export class AutogenModelProcessLog<RowType extends ModelRow> extends Endpoint<RowType, RowProcessLogFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowProcessLog extends ModelRow<RowProcessLogFields> {
	constructor(values?: Partial<RowProcessLogFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowProcessLogFields {
	class_name: string;
	company_id: string;
	date_run: Date;
	descr: string;
	execution_time: number;
	id: string;
	parameters_used: string;
	process_type: string;
	results: string;
	user_id: string;
}

